// extracted by mini-css-extract-plugin
export default {"transcript-header":"styles_transcript-header__3DZMd","right-block-wrapper":"styles_right-block-wrapper__9xxc1","loader":"styles_loader__5-TLK"};